export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/swipe-cell/index.js